import { use } from 'i18next'
import Backend from 'i18next-http-backend'
import { initReactI18next } from 'react-i18next'

import i18n from './config'

use(Backend).use(initReactI18next)

export default i18n
